export default function ExperienceSection() {
  const learnings = [
    'estruturar ideias com clareza',
    'controlar nervosismo ao falar',
    'usar postura e voz com impacto',
    'organizar pensamentos rapidamente',
    'comunicar com segurança'
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3">
            O que você vai <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#F19E1A] to-[#e08d0f]">experimentar</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Durante o VoxDay você vai aprender a:
          </p>
        </div>

        {/* Layout em 2 colunas equilibradas */}
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 items-start mb-12">
          {/* Coluna Esquerda - Lista de aprendizados (3 colunas) */}
          <div className="lg:col-span-3 order-1">
            <div className="space-y-4">
              {learnings.map((learning, index) => (
                <div 
                  key={index}
                  className="flex items-center gap-4 bg-gradient-to-r from-[#F19E1A]/10 to-transparent rounded-xl p-5 border-l-4 border-[#F19E1A] hover:shadow-lg hover:from-[#F19E1A]/15 transition-all duration-300"
                >
                  <div className="flex-shrink-0">
                    <div className="w-10 h-10 bg-[#F19E1A] rounded-full flex items-center justify-center shadow-lg">
                      <i className="ri-check-line text-white text-xl font-bold"></i>
                    </div>
                  </div>
                  <p className="text-lg font-semibold text-gray-800">
                    {learning}
                  </p>
                </div>
              ))}
            </div>
          </div>
          
          {/* Coluna Direita - Foto (2 colunas) */}
          <div className="lg:col-span-2 order-2">
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-br from-[#F19E1A]/20 to-[#e08d0f]/20 rounded-2xl blur-xl"></div>
              <div className="relative overflow-hidden rounded-2xl shadow-2xl border-4 border-white">
                <img
                  src="/images/voxday/5.jpeg"
                  alt="Experiência VoxDay"
                  className="w-full h-auto object-cover"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="bg-gradient-to-br from-gray-900 to-gray-800 text-white rounded-2xl p-8 text-center">
          <i className="ri-star-line text-[#F19E1A] text-4xl mb-3 inline-block"></i>
          <p className="text-xl md:text-2xl font-bold mb-3">
            Ao final do evento
          </p>
          <p className="text-lg max-w-2xl mx-auto">
            Você terá uma <strong className="text-[#F19E1A]">nova percepção</strong> sobre sua própria comunicação.
          </p>
        </div>
      </div>
    </section>
  );
}
